import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import styles from './style/benefit_style.module.scss'
import Typography from '../../foundations/typography/Typography'
import Icon, { IconMap } from '../../foundations/icon/Icon'

const Benefit = ({ children, className = '', icon, ...props }) => {

    return (
        <div className={`${styles.benefit} ${className}`} >
            <div className={`${styles['benefit-icon']}`}>
                <Icon img={icon} />
            </div>

            <Typography typeface="title-m-medium" block {...props} className={`${styles['benefit-title']}`} >
                {children[0]}
            </Typography>

            <Typography typeface="body-s-light" block {...props} className={`${styles['benefit-desc']}`}>
                {children[1]}
            </Typography>
        </div>
    )
};

Benefit.propTypes = {
    icon: PropTypes.oneOf(Object.keys(IconMap)).isRequired
}

export default Benefit;